import {Menu} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {SiteEntity} from "@ots-frontend/ots-data";
import {useCallback, useMemo} from "react";
import {useAuth} from "../../../providers/AuthProvider/AuthProvider";
import {IconEdit} from "@tabler/icons-react";
import {useSiteAction} from "./useSiteAction";

export type SiteAction = "EDIT" | "TOGGLE_TRANSPORT_VIA_PIPELINE" | "TOGGLE_TRANSPORT_OIL_VIA_PIPELINE"

export type SiteActionMenuDropdownProps = {
  site: SiteEntity
  onActionClick?: (action: SiteAction) => void
}

export const SiteActionMenuDropdown = (props: SiteActionMenuDropdownProps) => {
  const {site, onActionClick} = props

  const {hasAccess, hasEntityAccess} = useAuth()
  const {t} = useTranslation(["common"])

  const actions: Set<SiteAction> = useMemo(() => {
    const actions = new Set<SiteAction>()

    const canEditSite = hasEntityAccess(site, "site_edit")

    if (canEditSite) {
      actions.add("EDIT")
    }

    if (hasAccess("dispatchrequest_edit")) {
      actions.add("TOGGLE_TRANSPORT_VIA_PIPELINE")
      actions.add("TOGGLE_TRANSPORT_OIL_VIA_PIPELINE")
    }

    return actions
  }, [site, hasAccess, hasEntityAccess])

  const {
    onSiteActionClick
  } = useSiteAction()

  const _onActionClick = useCallback((action: SiteAction) => {
    if (onActionClick) {
      onActionClick(action)
    } else {
      onSiteActionClick(site, action)
    }
  }, [onActionClick, onSiteActionClick, site])

  return (
    <>
      {actions.size === 0 &&
        <Menu.Item>
          {t("common.action.none", "No Actions")}
        </Menu.Item>
      }
      {actions.has("EDIT") &&
        <Menu.Item
          onClick={() => _onActionClick("EDIT")}
          icon={<IconEdit size={14}/>}>
          {t("common.action.edit", "Edit")}
        </Menu.Item>
      }
      {actions.has("TOGGLE_TRANSPORT_VIA_PIPELINE") &&
        <Menu.Item onClick={() => _onActionClick("TOGGLE_TRANSPORT_VIA_PIPELINE")}>
          {site.transportViaPipeline ? t("common.action.marktransportviapipeline.false", "Mark Transport Water Via Truck") : t("common.action.marktransportviapipeline.true", "Mark Transport Water Via Pipeline")}
        </Menu.Item>
      }
      {actions.has("TOGGLE_TRANSPORT_OIL_VIA_PIPELINE") &&
        <Menu.Item onClick={() => _onActionClick("TOGGLE_TRANSPORT_OIL_VIA_PIPELINE")}>
          {site.transportViaPipeline ? t("common.action.marktransportoilviapipeline.false", "Mark Transport Oil Via Truck") : t("common.action.marktransportoilviapipeline.true", "Mark Transport Oil Via Pipeline")}
        </Menu.Item>
      }
    </>
  )
}
